import React from 'react';
import { Square, ChevronRight } from 'lucide-react';
import { ROOM_COLORS } from '../utils/constants';
import { polygonArea, formatArea } from '../utils/geometry';

export function SpaceListPanel({
  spaces,
  points,
  selectedSpaceId,
  onSelectSpace,
  embedded = false,
}) {
  if (spaces.length === 0) {
    return null;
  }

  // Fläche für einen Raum berechnen
  const getSpaceArea = (space) => {
    const polygon = (space.pointIds || [])
      .map(pid => points.find(p => p.id === pid))
      .filter(Boolean);
    return polygonArea(polygon);
  };

  const content = (
    <div className="max-h-48 overflow-y-auto">
      {spaces.map(space => {
        const isSelected = space.id === selectedSpaceId;
        const color = ROOM_COLORS[space.colorIndex % ROOM_COLORS.length];
        const area = getSpaceArea(space);

        return (
          <button
            key={space.id}
            onClick={() => onSelectSpace?.(space.id)}
            className={`w-full flex items-center gap-2 px-3 py-2 text-left hover:bg-gray-50 ${
              isSelected ? 'bg-blue-50' : ''
            }`}
          >
            <div
              className="w-4 h-4 rounded"
              style={{ backgroundColor: color }}
            />
            <div className="flex-1 min-w-0">
              <div className="text-sm font-medium text-gray-800 truncate">
                {space.name || 'Raum'}
              </div>
              <div className="text-xs text-gray-500">
                {formatArea(area)} m²
              </div>
            </div>
            {isSelected && (
              <ChevronRight size={16} className="text-blue-500" />
            )}
          </button>
        );
      })}
    </div>
  );

  // Im embedded-Modus direkt den Inhalt zurückgeben
  if (embedded) {
    return content;
  }

  // Standalone mit eigenem Container
  return (
    <div
      className="absolute left-4 bottom-4 bg-white rounded-lg shadow-lg z-10 w-56"
      onMouseDown={(e) => e.stopPropagation()}
      onClick={(e) => e.stopPropagation()}
    >
      <div className="p-2 border-b">
        <h4 className="text-sm font-semibold text-gray-700">
          Räume ({spaces.length})
        </h4>
      </div>
      {content}
    </div>
  );
}
